import { countSuppliersOnWorkTray, supplyService } from '@/services/supplyService';
import { dashboardService } from '@/services/dashboardService';
import { tryReadMergedFromCache } from '@/utils/supplyTableCache';
import {
  countSupplyUrgentProducts,
  getSupplyTableParamsForHomeKpis,
  readSupplyApplyMoqMpFromSession,
} from '@/utils/supplyKpiAlignment';

export interface HomeAlertStats {
  urgentProducts: number;
  suppliersToReview: number;
  pendingOrdersToReceive: number;
}

async function fetchUrgentProductsCount(warehouseId: number, applyMoqMp: boolean): Promise<number> {
  const cached = tryReadMergedFromCache(warehouseId, applyMoqMp);
  if (cached?.data?.length) {
    return countSupplyUrgentProducts(cached.data);
  }

  const response = await supplyService.getSupplyTableData(
    getSupplyTableParamsForHomeKpis(warehouseId, applyMoqMp),
  );

  if (response.table_metrics?.products_urgent != null) {
    return response.table_metrics.products_urgent;
  }
  return response.table_metrics?.products_needing_reorder ?? 0;
}

export const homeService = {
  async getAlertStats(warehouseId: number): Promise<HomeAlertStats> {
    const applyMoqMp = readSupplyApplyMoqMpFromSession();

    const [workTray, summary, urgentProducts] = await Promise.all([
      supplyService.getSuppliersWithoutRecentOrders(warehouseId, false, applyMoqMp),
      dashboardService.getHomeSummary(warehouseId),
      fetchUrgentProductsCount(warehouseId, applyMoqMp),
    ]);

    return {
      urgentProducts,
      suppliersToReview: countSuppliersOnWorkTray(workTray),
      pendingOrdersToReceive: summary.pending_orders_to_receive ?? 0,
    };
  },
};
